import * as React from 'react'

import { Alert, Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import useRestoreFromTrashBinDocument from 'modules/documents/hooks/documents/useRestoreFromTrashBinDocument'
import { MAX_DAYS_TO_BE_DELETED } from 'modules/documents/lib/constants'

interface Props {
  documentId: number
  documentDeletedAt: string
  onRestore?: () => void
}

const RestoreFromTrashBinBox = ({ documentId, documentDeletedAt, onRestore }: Props) => {
  const { restoreDocumentsFromTrashBin, loading: loading } = useRestoreFromTrashBinDocument({
    fromDataTable: true,
  })
  const restoreDocument = async () => {
    const result = await restoreDocumentsFromTrashBin({ documentIds: [documentId] })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('documents.modal.restoreFromTrashBinBox.success'),
      })
      onRestore && onRestore()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_saving'),
      })
    }
  }

  const difference_days = MAX_DAYS_TO_BE_DELETED - moment().diff(moment(documentDeletedAt), 'days')
  const days = difference_days < 0 ? 0 : difference_days

  return (
    <Alert color="warning">
      <Box gap="s12">
        <Box gap="s16">
          <Box gap="s8">
            <Box flexDirection="row" gap="s4">
              <Icon.Medium icon="delete" color="tangerine1000"></Icon.Medium>
              <Text.Normal weight="semibold">
                {i18n.t('documents.modal.restoreFromTrashBinBox.title')}
              </Text.Normal>
            </Box>
            <Text.Normal>
              {i18n.t('documents.modal.restoreFromTrashBinBox.description', { count: days })}
            </Text.Normal>
          </Box>
          <Button
            type="secondary"
            onClick={restoreDocument}
            disabled={loading}
            iconName={loading ? 'delete' : undefined}
          >
            {i18n.t('documents.modal.restoreFromTrashBinBox.button')}
          </Button>
        </Box>
      </Box>
    </Alert>
  )
}

export default RestoreFromTrashBinBox
